import clsx from "clsx";
import { FC } from "react";

import { ProductCard } from "@/components/Layout/BaseLayouts/ProductCard/ProductCard";
import { ProductCardFooterBox } from "@/components/Layout/BaseLayouts/ProductCard/ProductCardFooterItem";

const placeholderClassName =
  "placeholder animate-pulse rounded bg-surface-secondary opacity-25";

const SkeletonBar = ({ className }: { className?: string }) => (
  <div className={clsx(placeholderClassName, className)} />
);

const SkeletonProgressFooter = () => (
  <ProductCardFooterBox>
    <SkeletonBar className="h-4 w-1/3" />
    <div className="flex w-full flex-col items-start gap-2">
      <SkeletonBar className="h-1 w-full rounded-full" />
      <SkeletonBar className="h-3.5 w-1/2" />
    </div>
  </ProductCardFooterBox>
);

/**
 * Loading stand-in for the ProductCard-based device tiles (Active, Inactive,
 * …). Mirrors the loaded header/footer geometry so the grid does not jump
 * when real cards replace these placeholders.
 */
export const SkeletonTile: FC = () => (
  <div aria-hidden>
    <ProductCard
      dataTestid="skeleton-tile"
      header={
        <div className="relative flex h-full w-full flex-col items-start gap-3 pt-4">
          <SkeletonBar className="absolute right-0 top-0 h-8 w-24" />
          <SkeletonBar className="size-14 shrink-0" />
          <div className="flex w-full flex-col gap-1">
            <SkeletonBar className="h-7 w-3/4" />
            <SkeletonBar className="h-6 w-1/2" />
          </div>
          <SkeletonBar className="h-6 w-16 rounded-full" />
        </div>
      }
      footer={
        <div className="flex w-full flex-col gap-3">
          <SkeletonProgressFooter />
          <SkeletonProgressFooter />
        </div>
      }
    />
  </div>
);
